import { ɵɵdefineInjectable, ɵɵinject, Injectable, Component, Input, Inject, Optional, Pipe, NgModule } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { KeyboardKeys, KeyboardShortcutModule } from '@mt-ng2/keyboard-shortcuts-module';
import { BackButtonModuleConfigToken } from '@mt-ng2/back-button-module-config';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from 'ngx-keyboard-shortcuts';
import * as ɵngcc5 from '@angular/platform-browser';

function BackButtonComponent_span_1_li_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "a", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵtext(5, "\n                        ");
    ɵngcc0.ɵɵelementStart(6, "span", 10);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("routerLink", link_r2.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                        ", link_r2.title, "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(link_r2.url);
} }
function BackButtonComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1, "\n        ");
    ɵngcc0.ɵɵelementStart(2, "a", 2);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelement(4, "i", 3);
    ɵngcc0.ɵɵtext(5, "\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n        ");
    ɵngcc0.ɵɵelementStart(7, "span", 4);
    ɵngcc0.ɵɵtext(8, "\n            ");
    ɵngcc0.ɵɵelementStart(9, "button", 5);
    ɵngcc0.ɵɵtext(10, "\n                ");
    ɵngcc0.ɵɵelement(11, "span", 6);
    ɵngcc0.ɵɵtext(12, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, "\n            ");
    ɵngcc0.ɵɵelementStart(14, "ul", 7);
    ɵngcc0.ɵɵtext(15, "\n                ");
    ɵngcc0.ɵɵtemplate(16, BackButtonComponent_span_1_li_16_Template, 10, 3, "li", 8);
    ɵngcc0.ɵɵtext(17, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, "\n        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.getBackRouterLink());
    ɵngcc0.ɵɵattribute("title", ctx_r0.getBackRouteTitle());
    ɵngcc0.ɵɵadvance(14);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.routerLinks);
} }
function CloseButtonComponent_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 2);
    ɵngcc0.ɵɵlistener("click", function CloseButtonComponent_ng_container_1_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.clicked($event); });
    ɵngcc0.ɵɵpipe(1, "safe");
    ɵngcc0.ɵɵtext(2, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.getBackRouterLink())("keyboardShortcut", ctx_r2.shortcutKey)("innerHtml", ɵngcc0.ɵɵpipeBind2(1, 4, ctx_r2.buttonInnerHtml, "html"), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("title", ctx_r2.getBackRouteTitle());
} }
function CloseButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, CloseButtonComponent_ng_container_1_a_2_Template, 3, 7, "a", 1);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showButton);
} }
function CloseButtonComponent_ng_container_3_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function CloseButtonComponent_ng_container_3_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.clicked($event); });
    ɵngcc0.ɵɵpipe(1, "safe");
    ɵngcc0.ɵɵtext(2, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r5.getBackRouterLink())("innerHtml", ɵngcc0.ɵɵpipeBind2(1, 3, ctx_r5.buttonInnerHtml, "html"), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("title", ctx_r5.getBackRouteTitle());
} }
function CloseButtonComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, CloseButtonComponent_ng_container_3_a_2_Template, 3, 6, "a", 3);
    ɵngcc0.ɵɵtext(3, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showButton);
} }
class BackButtonRouterLinks {
}
class RouterLinkBuilder {
    constructor(router) {
        this.router = router;
    }
    getAllRouterLinksBasedOnRoute() {
        const url = this.router.parseUrl(this.router.url);
        if (!(url && url.root && url.root.children && url.root.children.primary)) {
            return [];
        }
        let segments = url.root.children.primary.segments;
        segments = segments.slice(0, segments.length - 1);
        let routerLinks = [];
        segments.forEach((segment, i) => {
            const url = segments
                .slice(0, i + 1)
                .map((item) => item.path)
                .join('/');
            const routerLink = this.getRouterLink(url);
            routerLinks.unshift(routerLink);
        });
        return routerLinks;
    }
    getRouterLink(url) {
        let urlWithoutSlash = url;
        if (url.startsWith('/')) {
            urlWithoutSlash = url.substring(1);
        }
        else {
            url = '/' + url;
        }
        return {
            title: this.getRouteTitle(urlWithoutSlash),
            url: url,
        };
    }
    getRouteTitle(url) {
        let urlSplit = url.split('/');
        let configs = [...this.router.config];
        let configsToEnumerate = [...this.router.config];
        configsToEnumerate.forEach((c) => {
            this.addChildren(configs, c);
        });
        let config = configs.find((c) => {
            let pathSplit = c.path.split('/');
            if (pathSplit.length !== urlSplit.length) {
                return false;
            }
            let match = true;
            pathSplit.forEach((p, i) => {
                let matchingUrlSegment = urlSplit[i];
                if (!matchingUrlSegment) {
                    match = false;
                }
                if (p !== matchingUrlSegment) {
                    if (!p.startsWith(':')) {
                        match = false;
                    }
                    // tslint:disable-next-line:radix
                    let isNumber = parseInt(matchingUrlSegment);
                    if (!isNumber) {
                        match = false;
                    }
                }
            });
            return match;
        });
        return (config && config.data && config.data.title) || '';
    }
    addChildren(configs, config) {
        if (!config.children) {
            return;
        }
        config.children.forEach((c) => {
            let copy = Object.assign({}, c);
            copy.path = config.path + '/' + copy.path;
            configs.push(copy);
            this.addChildren(configs, c);
        });
    }
}

class BackButtonService {
    constructor(router) {
        this.router = router;
        this.routerLinks = new BehaviorSubject(null);
        this.currentNavigationRouterLink = new BehaviorSubject(null);
        this.previousNavigationRouterLink = new BehaviorSubject(null);
        this.routerLinkBuilder = new RouterLinkBuilder(this.router);
        this.setRouterLinks();
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                if (this.currentNavigationRouterLink.getValue()) {
                    this.previousNavigationRouterLink.next(this.currentNavigationRouterLink.getValue());
                }
                this.currentNavigationRouterLink.next(this.routerLinkBuilder.getRouterLink(val.url));
                this.setRouterLinks();
            }
        });
    }
    setRouterLinks() {
        this.routerLinks.next(this.routerLinkBuilder.getAllRouterLinksBasedOnRoute());
    }
    goBack() {
        const routerLinks = this.routerLinks.getValue();
        const routerLink = (routerLinks && routerLinks[0]) || null;
        if (routerLink) {
            this.router.navigateByUrl(routerLink.url);
        }
    }
}
BackButtonService.ɵfac = function BackButtonService_Factory(t) { return new (t || BackButtonService)(ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
BackButtonService.ɵprov = ɵɵdefineInjectable({ factory: function BackButtonService_Factory() { return new BackButtonService(ɵɵinject(Router)); }, token: BackButtonService, providedIn: "root" });
BackButtonService.ctorParameters = () => [
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BackButtonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Router }]; }, null); })();

class BackButtonComponent {
    constructor(router, backButtonService) {
        this.router = router;
        this.backButtonService = backButtonService;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.backButtonService.routerLinks.subscribe((routerLinks) => {
            if (!this.urlSegmentsToIgnore || !this.urlSegmentsToIgnore.length) {
                this.routerLinks = routerLinks;
            }
            else {
                this.routerLinks = routerLinks.filter((link) => {
                    const urlSegments = link.url.split('/');
                    const lastSegment = urlSegments[urlSegments.length - 1];
                    const segmentShouldBeIgnored = this.urlSegmentsToIgnore.some((segment) => segment === lastSegment);
                    return !segmentShouldBeIgnored;
                });
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    goBack() {
        this.navigateByRouterLink(this.routerLinks[0]);
    }
    getBackRouteTitle() {
        const title = (this.routerLinks && this.routerLinks[0] && this.routerLinks[0].title) || '';
        return title ? `back to ${title}` : null;
    }
    getBackRouterLink() {
        return this.routerLinks[0].url;
    }
    navigateByRouterLink(routerLink) {
        this.router.navigateByUrl(routerLink.url);
    }
}
BackButtonComponent.ɵfac = function BackButtonComponent_Factory(t) { return new (t || BackButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(BackButtonService)); };
BackButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BackButtonComponent, selectors: [["route-back-button"]], inputs: { urlSegmentsToIgnore: "urlSegmentsToIgnore" }, decls: 2, vars: 1, consts: [["class", "btn-group", 4, "ngIf"], [1, "btn-group"], [1, "btn", "btn-primary", "back-button", 3, "routerLink"], [1, "fa", "fa-chevron-left"], ["ngbDropdown", "", 1, "btn-group", "dropdown"], ["ngbDropdownToggle", "", "type", "button", 1, "btn", "btn-primary", "dropdown-toggle"], [1, "caret"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], [4, "ngFor", "ngForOf"], [3, "routerLink"], [1, "small"]], template: function BackButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, " ");
        ɵngcc0.ɵɵtemplate(1, BackButtonComponent_span_1_Template, 20, 3, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.routerLinks && ctx.routerLinks.length > 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc1.RouterLinkWithHref, ɵngcc3.NgbDropdown, ɵngcc3.NgbDropdownToggle, ɵngcc3.NgbDropdownMenu, ɵngcc2.NgForOf], styles: [".show.dropdown[_ngcontent-%COMP%] {\n                display: inline !important;\n            }\n            .back-button[_ngcontent-%COMP%] {\n                padding-left: 4px;\n                padding-right: 6px;\n                padding-top: 3px;\n                padding-bottom: 0;\n                margin-top: -3px;\n            }\n            .dropdown-toggle[_ngcontent-%COMP%] {\n                padding-left: 2px;\n                padding-right: 2px;\n                padding-top: 2px;\n                padding-bottom: 1px;\n            }\n            .dropdown-menu[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%]    > a[_ngcontent-%COMP%] {\n                cursor: pointer;\n                padding-left: 20px;\n                padding-right: 20px;\n                padding-top: 6px;\n                padding-bottom: 3px;\n                line-height: 0.8;\n            }\n            .btn-group[_ngcontent-%COMP%] {\n                margin-top: -3px;\n            }"] });
BackButtonComponent.ctorParameters = () => [
    { type: Router },
    { type: BackButtonService }
];
BackButtonComponent.propDecorators = {
    urlSegmentsToIgnore: [{ type: Input, args: ['urlSegmentsToIgnore',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BackButtonComponent, [{
        type: Component,
        args: [{
                selector: 'route-back-button',
                template: ` <span *ngIf="routerLinks && routerLinks.length > 0" class="btn-group">
        <a class="btn btn-primary back-button" [routerLink]="getBackRouterLink()" [attr.title]="getBackRouteTitle()">
            <i class="fa fa-chevron-left"></i>
        </a>
        <span ngbDropdown class="btn-group dropdown">
            <button ngbDropdownToggle class="btn btn-primary dropdown-toggle" type="button">
                <span class="caret"></span>
            </button>
            <ul ngbDropdownMenu class="dropdown-menu">
                <li *ngFor="let link of routerLinks">
                    <a [routerLink]="link.url">
                        {{ link.title }}<br />
                        <span class="small">{{ link.url }}</span>
                    </a>
                </li>
            </ul>
        </span>
    </span>`,
                styles: [`
            .show.dropdown {
                display: inline !important;
            }
            .back-button {
                padding-left: 4px;
                padding-right: 6px;
                padding-top: 3px;
                padding-bottom: 0;
                margin-top: -3px;
            }
            .dropdown-toggle {
                padding-left: 2px;
                padding-right: 2px;
                padding-top: 2px;
                padding-bottom: 1px;
            }
            .dropdown-menu > li > a {
                cursor: pointer;
                padding-left: 20px;
                padding-right: 20px;
                padding-top: 6px;
                padding-bottom: 3px;
                line-height: 0.8;
            }
            .btn-group {
                margin-top: -3px;
            }
        `]
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: BackButtonService }]; }, { urlSegmentsToIgnore: [{
            type: Input,
            args: ['urlSegmentsToIgnore']
        }] }); })();

const defaultModuleConfig = {
    hasKeyboardShortcutsModule: false,
};
class BackButtonModuleConfig {
    constructor(config) {
        Object.assign(this, defaultModuleConfig, config);
    }
}
BackButtonModuleConfig.ɵfac = function BackButtonModuleConfig_Factory(t) { return new (t || BackButtonModuleConfig)(ɵngcc0.ɵɵinject(BackButtonModuleConfigToken, 8)); };
BackButtonModuleConfig.ɵprov = ɵɵdefineInjectable({ factory: function BackButtonModuleConfig_Factory() { return new BackButtonModuleConfig(ɵɵinject(BackButtonModuleConfigToken, 8)); }, token: BackButtonModuleConfig, providedIn: "root" });
BackButtonModuleConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BackButtonModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BackButtonModuleConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BackButtonModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

var CloseButtonStrategy;
(function (CloseButtonStrategy) {
    CloseButtonStrategy[CloseButtonStrategy["Route"] = 0] = "Route";
    CloseButtonStrategy[CloseButtonStrategy["History"] = 1] = "History";
})(CloseButtonStrategy || (CloseButtonStrategy = {}));
class CloseButtonComponent {
    constructor(router, backButtonService, moduleConfig) {
        this.router = router;
        this.backButtonService = backButtonService;
        this.moduleConfig = moduleConfig;
        this.buttonInnerHtml = this.hasShortcutKeys ? '<strong style="text-decoration: underline;">C</strong>lose' : 'Close';
        this.shortcutKey = {
            description: 'Close button',
            keyBinding: [KeyboardKeys.Alt, 'C'],
        };
        this.stopClickPropagation = false;
        this.strategy = CloseButtonStrategy.Route;
        this.subscriptions = new Subscription();
        this.showButton = false;
    }
    get hasShortcutKeys() {
        return this.moduleConfig.hasKeyboardShortcutsModule;
    }
    ngOnInit() {
        if (this.strategy === CloseButtonStrategy.Route) {
            this.addRouteSubscription();
        }
        else {
            this.addHistorySubscription();
        }
    }
    addRouteSubscription() {
        this.subscriptions.add(this.backButtonService.routerLinks.subscribe((routerLinks) => {
            if (!this.urlSegmentsToIgnore || !this.urlSegmentsToIgnore.length) {
                this.routerLinks = routerLinks;
            }
            else {
                this.routerLinks = routerLinks.filter((link) => {
                    const urlSegments = link.url.split('/');
                    const lastSegment = urlSegments[urlSegments.length - 1];
                    const segmentShouldBeIgnored = this.urlSegmentsToIgnore.some((segment) => segment === lastSegment);
                    return !segmentShouldBeIgnored;
                });
            }
            this.showButton = routerLinks.length ? true : false;
        }));
    }
    addHistorySubscription() {
        this.subscriptions.add(this.backButtonService.previousNavigationRouterLink.subscribe((link) => {
            if (link) {
                this.routerLinks = [link];
                this.showButton = true;
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    goBack() {
        this.navigateByRouterLink(this.routerLinks[0]);
    }
    getBackRouteTitle() {
        const title = (this.routerLinks && this.routerLinks[0] && this.routerLinks[0].title) || '';
        return title ? `back to ${title}` : null;
    }
    getBackRouterLink() {
        return this.routerLinks[0].url;
    }
    clicked(event) {
        if (this.stopClickPropagation) {
            event.stopPropagation();
        }
    }
    navigateByRouterLink(routerLink) {
        this.router.navigateByUrl(routerLink.url);
    }
}
CloseButtonComponent.ɵfac = function CloseButtonComponent_Factory(t) { return new (t || CloseButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(BackButtonService), ɵngcc0.ɵɵdirectiveInject(BackButtonModuleConfig)); };
CloseButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CloseButtonComponent, selectors: [["close-button"]], inputs: { buttonInnerHtml: "buttonInnerHtml", shortcutKey: ["shortcutKeyCombination", "shortcutKey"], stopClickPropagation: "stopClickPropagation", strategy: "strategy", urlSegmentsToIgnore: "urlSegmentsToIgnore" }, decls: 5, vars: 2, consts: [[4, "ngIf"], ["class", "btn btn-default", 3, "routerLink", "keyboardShortcut", "innerHtml", "click", 4, "ngIf"], [1, "btn", "btn-default", 3, "routerLink", "keyboardShortcut", "innerHtml", "click"], ["class", "btn btn-default", 3, "routerLink", "innerHtml", "click", 4, "ngIf"], [1, "btn", "btn-default", 3, "routerLink", "innerHtml", "click"]], template: function CloseButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CloseButtonComponent_ng_container_1_Template, 4, 1, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, CloseButtonComponent_ng_container_3_Template, 4, 1, "ng-container", 0);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasShortcutKeys);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasShortcutKeys);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc1.RouterLinkWithHref, ɵngcc4.KeyboardShortcutDirective]; }, pipes: function () { return [SafePipe]; }, encapsulation: 2 });
CloseButtonComponent.ctorParameters = () => [
    { type: Router },
    { type: BackButtonService },
    { type: BackButtonModuleConfig }
];
CloseButtonComponent.propDecorators = {
    buttonInnerHtml: [{ type: Input, args: ['buttonInnerHtml',] }],
    shortcutKey: [{ type: Input, args: ['shortcutKeyCombination',] }],
    stopClickPropagation: [{ type: Input, args: ['stopClickPropagation',] }],
    strategy: [{ type: Input, args: ['strategy',] }],
    urlSegmentsToIgnore: [{ type: Input, args: ['urlSegmentsToIgnore',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CloseButtonComponent, [{
        type: Component,
        args: [{
                selector: 'close-button',
                template: `
        <ng-container *ngIf="hasShortcutKeys">
            <a
                *ngIf="showButton"
                [routerLink]="getBackRouterLink()"
                class="btn btn-default"
                [keyboardShortcut]="shortcutKey"
                (click)="clicked($event)"
                [attr.title]="getBackRouteTitle()"
                [innerHtml]="buttonInnerHtml | safe: 'html'"
            >
            </a>
        </ng-container>
        <ng-container *ngIf="!hasShortcutKeys">
            <a
                *ngIf="showButton"
                [routerLink]="getBackRouterLink()"
                class="btn btn-default"
                (click)="clicked($event)"
                [attr.title]="getBackRouteTitle()"
                [innerHtml]="buttonInnerHtml | safe: 'html'"
            >
            </a>
        </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: BackButtonService }, { type: BackButtonModuleConfig }]; }, { buttonInnerHtml: [{
            type: Input,
            args: ['buttonInnerHtml']
        }], shortcutKey: [{
            type: Input,
            args: ['shortcutKeyCombination']
        }], stopClickPropagation: [{
            type: Input,
            args: ['stopClickPropagation']
        }], strategy: [{
            type: Input,
            args: ['strategy']
        }], urlSegmentsToIgnore: [{
            type: Input,
            args: ['urlSegmentsToIgnore']
        }] }); })();

// this could be moved to a separate package
class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
SafePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }]; }, null); })();

class BackButtonModule {
}
BackButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BackButtonModule });
BackButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BackButtonModule_Factory(t) { return new (t || BackButtonModule)(); }, imports: [[CommonModule, RouterModule, NgbModule, KeyboardShortcutModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BackButtonModule, { declarations: function () { return [BackButtonComponent, CloseButtonComponent, SafePipe]; }, imports: function () { return [CommonModule, RouterModule, NgbModule, KeyboardShortcutModule]; }, exports: function () { return [BackButtonComponent, CloseButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BackButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [BackButtonComponent, CloseButtonComponent, SafePipe],
                exports: [BackButtonComponent, CloseButtonComponent],
                imports: [CommonModule, RouterModule, NgbModule, KeyboardShortcutModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BackButtonComponent, BackButtonModule, BackButtonService, CloseButtonComponent, CloseButtonStrategy, BackButtonModuleConfig as ɵa, SafePipe as ɵb };

//# sourceMappingURL=mt-ng2-back-button-module.js.map